import { defineEffect } from '../../../core/effect';
import { newPhaseSpec } from '../fx/newPhase';

/** バトルフェイズ（炎の板・鋼の板・左右の剣）（Issue #589。状況は共通側の `editorPorts/duelSituations/new_phase.js` が決め、絵の組み立ては `../fx/newPhase.js`） */
export default defineEffect({ situation: 'new_phase_battle', role: 'effect', ...newPhaseSpec(true) }, 'new_phase_battle_effect.js');
